import { useState } from "react";
import {
    Search,
    Phone,
    Video,
    MoreVertical,
    Send,
    Paperclip,
    Smile,
    Image,
    Mic,
    Check,
    CheckCheck,
    Star,
    ArrowLeft
} from "lucide-react";

const contacts = [
    {
        id: 1,
        name: "Nia Hillyer",
        avatar: "NH",
        lastMessage: "How do you do? and what are you doing..",
        time: "2:09 PM",
        unread: 2,
        online: true,
        color: "from-pink-500 to-rose-500"
    },
    {
        id: 2,
        name: "Sean Freeman",
        avatar: "SF",
        lastMessage: "I was wondering...",
        time: "12:09 PM",
        unread: 0,
        online: true,
        color: "from-blue-500 to-indigo-500"
    },
    {
        id: 3,
        name: "Alma Clarke",
        avatar: "AC",
        lastMessage: "I've forgotten how it felt before",
        time: "1:44 PM",
        unread: 1,
        online: false,
        color: "from-amber-500 to-orange-500"
    },
    {
        id: 4,
        name: "Alan Green",
        avatar: "AG",
        lastMessage: "But we're probably gonna need...",
        time: "2:06 PM",
        unread: 0,
        online: true,
        color: "from-emerald-500 to-teal-500"
    },
    {
        id: 5,
        name: "Shaun Park",
        avatar: "SP",
        lastMessage: "It's not that bad...",
        time: "2:05 PM",
        unread: 0,
        online: false,
        color: "from-purple-500 to-violet-500"
    },
    {
        id: 6,
        name: "Emma Watson",
        avatar: "EW",
        lastMessage: "Thanks for the lovely evening!",
        time: "11:30 AM",
        unread: 0,
        online: true,
        color: "from-cyan-500 to-blue-500"
    }
];

const messages = [
    { id: 1, sender: "them", text: "Hey there! How are you doing?", time: "2:00 PM", status: "read" },
    { id: 2, sender: "me", text: "Hi! I'm doing great, thanks for asking. How about you?", time: "2:02 PM", status: "read" },
    { id: 3, sender: "them", text: "I'm good! Just wanted to check if you're free this weekend?", time: "2:05 PM", status: "read" },
    { id: 4, sender: "me", text: "Yes, I'm free on Saturday. Did you have something in mind?", time: "2:07 PM", status: "read" },
    { id: 5, sender: "them", text: "There's this new coffee place downtown. Would you like to check it out together?", time: "2:08 PM", status: "read" },
    { id: 6, sender: "me", text: "That sounds wonderful! I'd love to. What time works for you?", time: "2:09 PM", status: "delivered" },
];

export default function Chat() {
    const [activeTab, setActiveTab] = useState("chats");
    const [selectedContact, setSelectedContact] = useState(null);
    const [messageInput, setMessageInput] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const tabs = [
        { id: "chats", label: "Chats", icon: "≡ƒÆ¼" },
        { id: "calls", label: "Calls", icon: "≡ƒô₧" },
        { id: "contacts", label: "Contacts", icon: "≡ƒæÑ" },
        { id: "notification", label: "Alerts", icon: "≡ƒöö" }
    ];

    const filteredContacts = contacts.filter(contact =>
        contact.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleBack = () => {
        setSelectedContact(null);
    };

    return (
        <div className="flex h-[calc(100vh-6rem)] lg:h-[calc(100vh-7rem)] bg-white dark:bg-slate-800 rounded-xl lg:rounded-2xl border border-gray-100 dark:border-gray-700 overflow-hidden shadow-xl shadow-gray-200/50 dark:shadow-black/20">
            {/* Left Panel - Contacts */}
            <div className={`w-full md:w-72 lg:w-80 border-r border-gray-100 dark:border-gray-700 flex flex-col flex-shrink-0
        ${selectedContact ? 'hidden md:flex' : 'flex'}`}>
                {/* User Profile Header */}
                <div className="p-3 lg:p-4 border-b border-gray-100 dark:border-gray-700">
                    <div className="flex items-center gap-2 lg:gap-3">
                        <div className="relative">
                            <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-white font-semibold text-sm lg:text-base">
                                AS
                            </div>
                            <span className="absolute bottom-0 right-0 w-2.5 h-2.5 lg:w-3.5 lg:h-3.5 bg-green-500 rounded-full ring-2 ring-white dark:ring-slate-800" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="font-semibold text-sm lg:text-base text-gray-800 dark:text-gray-200 truncate">Alon Smith</h3>
                            <p className="text-xs lg:text-sm text-gray-500 dark:text-gray-400">Software Developer</p>
                        </div>
                        <button className="p-1.5 lg:p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors">
                            <MoreVertical className="w-4 h-4 lg:w-5 lg:h-5 text-gray-500" />
                        </button>
                    </div>
                </div>

                {/* Search */}
                <div className="p-2 lg:p-3">
                    <div className="relative">
                        <Search className="absolute left-2.5 lg:left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 lg:w-4 lg:h-4 text-gray-400" />
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full pl-8 lg:pl-10 pr-3 lg:pr-4 py-2 lg:py-2.5 rounded-lg bg-gray-100 dark:bg-slate-700 text-xs lg:text-sm text-gray-700 dark:text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                        />
                    </div>
                </div>

                {/* Tabs */}
                <div className="px-2 lg:px-3 flex items-center gap-1 lg:gap-2 border-b border-gray-100 dark:border-gray-700 pb-2 lg:pb-3 overflow-x-auto">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex flex-col items-center gap-0.5 lg:gap-1 px-2.5 lg:px-4 py-1.5 lg:py-2 rounded-lg text-[10px] lg:text-xs font-medium transition-all flex-shrink-0
                ${activeTab === tab.id
                                    ? 'bg-blue-50 dark:bg-blue-500/10 text-blue-600 dark:text-blue-400'
                                    : 'text-gray-500 hover:bg-gray-100 dark:hover:bg-slate-700'}`}
                        >
                            <span className="text-sm lg:text-base">{tab.icon}</span>
                            <span>{tab.label}</span>
                        </button>
                    ))}
                </div>

                {/* Contacts List */}
                <div className="flex-1 overflow-y-auto">
                    {filteredContacts.map((contact) => (
                        <div
                            key={contact.id}
                            onClick={() => setSelectedContact(contact)}
                            className={`flex items-center gap-2 lg:gap-3 px-3 lg:px-4 py-2.5 lg:py-3 cursor-pointer transition-all
                ${selectedContact?.id === contact.id
                                    ? 'bg-blue-50 dark:bg-blue-500/10 border-r-2 border-blue-500'
                                    : 'hover:bg-gray-50 dark:hover:bg-slate-700/50'}`}
                        >
                            <div className="relative flex-shrink-0">
                                <div className={`w-9 h-9 lg:w-11 lg:h-11 rounded-full bg-gradient-to-br ${contact.color} flex items-center justify-center text-white font-semibold text-xs lg:text-sm`}>
                                    {contact.avatar}
                                </div>
                                {contact.online && (
                                    <span className="absolute bottom-0 right-0 w-2.5 h-2.5 lg:w-3 lg:h-3 bg-green-500 rounded-full ring-2 ring-white dark:ring-slate-800" />
                                )}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center justify-between mb-0.5 lg:mb-1">
                                    <h4 className="text-xs lg:text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{contact.name}</h4>
                                    <span className="text-[10px] lg:text-xs text-gray-400 flex-shrink-0 ml-2">{contact.time}</span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <p className="text-[10px] lg:text-xs text-gray-500 dark:text-gray-400 truncate pr-2">{contact.lastMessage}</p>
                                    {contact.unread > 0 && (
                                        <span className="flex-shrink-0 w-4 h-4 lg:w-5 lg:h-5 bg-gradient-to-r from-pink-500 to-rose-500 rounded-full flex items-center justify-center text-[8px] lg:text-[10px] text-white font-bold">
                                            {contact.unread}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Right Panel - Chat Area */}
            {selectedContact ? (
                <div className={`flex-1 flex flex-col ${selectedContact ? 'flex' : 'hidden md:flex'}`}>
                    {/* Chat Header */}
                    <div className="flex items-center justify-between px-3 lg:px-6 py-3 lg:py-4 border-b border-gray-100 dark:border-gray-700 bg-white dark:bg-slate-800">
                        <div className="flex items-center gap-2 lg:gap-3">
                            {/* Back Button for Mobile */}
                            <button
                                onClick={handleBack}
                                className="md:hidden p-1.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors"
                            >
                                <ArrowLeft className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                            </button>
                            <div className="relative">
                                <div className={`w-9 h-9 lg:w-11 lg:h-11 rounded-full bg-gradient-to-br ${selectedContact.color} flex items-center justify-center text-white font-semibold text-xs lg:text-sm`}>
                                    {selectedContact.avatar}
                                </div>
                                {selectedContact.online && (
                                    <span className="absolute bottom-0 right-0 w-2.5 h-2.5 lg:w-3 lg:h-3 bg-green-500 rounded-full ring-2 ring-white dark:ring-slate-800" />
                                )}
                            </div>
                            <div>
                                <h3 className="font-semibold text-sm lg:text-base text-gray-800 dark:text-gray-200">{selectedContact.name}</h3>
                                <p className="text-[10px] lg:text-xs text-green-500">
                                    {selectedContact.online ? "Online" : "Last seen 2h ago"}
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-1 lg:gap-2">
                            <button className="p-2 lg:p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors group">
                                <Phone className="w-4 h-4 lg:w-5 lg:h-5 text-gray-500 group-hover:text-blue-500" />
                            </button>
                            <button className="hidden sm:block p-2 lg:p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors group">
                                <Video className="w-4 h-4 lg:w-5 lg:h-5 text-gray-500 group-hover:text-blue-500" />
                            </button>
                            <button className="hidden sm:block p-2 lg:p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors group">
                                <Star className="w-4 h-4 lg:w-5 lg:h-5 text-gray-500 group-hover:text-amber-500" />
                            </button>
                            <button className="p-2 lg:p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors group">
                                <MoreVertical className="w-4 h-4 lg:w-5 lg:h-5 text-gray-500" />
                            </button>
                        </div>
                    </div>

                    {/* Messages Area */}
                    <div className="flex-1 overflow-y-auto p-3 lg:p-6 space-y-3 lg:space-y-4 bg-gray-50 dark:bg-slate-900/50">
                        {/* Date Divider */}
                        <div className="flex items-center justify-center">
                            <span className="px-3 lg:px-4 py-0.5 lg:py-1 bg-white dark:bg-slate-800 rounded-full text-[10px] lg:text-xs text-gray-500 dark:text-gray-400 shadow-sm">
                                Today
                            </span>
                        </div>

                        {messages.map((message) => (
                            <div
                                key={message.id}
                                className={`flex ${message.sender === "me" ? "justify-end" : "justify-start"}`}
                            >
                                <div
                                    className={`max-w-[85%] sm:max-w-[75%] lg:max-w-[70%] px-3 lg:px-4 py-2 lg:py-3 rounded-xl lg:rounded-2xl ${message.sender === "me"
                                            ? "bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-br-sm lg:rounded-br-md"
                                            : "bg-white dark:bg-slate-800 text-gray-700 dark:text-gray-200 rounded-bl-sm lg:rounded-bl-md shadow-sm"
                                        }`}
                                >
                                    <p className="text-xs lg:text-sm leading-relaxed">{message.text}</p>
                                    <div className={`flex items-center justify-end gap-1 mt-1 ${message.sender === "me" ? "text-white/70" : "text-gray-400"}`}>
                                        <span className="text-[8px] lg:text-[10px]">{message.time}</span>
                                        {message.sender === "me" && (
                                            message.status === "read" ? (
                                                <CheckCheck className="w-3 h-3 lg:w-3.5 lg:h-3.5 text-blue-200" />
                                            ) : (
                                                <Check className="w-3 h-3 lg:w-3.5 lg:h-3.5" />
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Message Input */}
                    <div className="px-3 lg:px-6 py-3 lg:py-4 border-t border-gray-100 dark:border-gray-700 bg-white dark:bg-slate-800">
                        <div className="flex items-center gap-2 lg:gap-3">
                            <div className="hidden sm:flex items-center gap-0.5 lg:gap-1">
                                <button className="p-2 lg:p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors group">
                                    <Smile className="w-4 h-4 lg:w-5 lg:h-5 text-gray-400 group-hover:text-amber-500" />
                                </button>
                                <button className="p-2 lg:p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors group">
                                    <Paperclip className="w-4 h-4 lg:w-5 lg:h-5 text-gray-400 group-hover:text-blue-500" />
                                </button>
                                <button className="hidden lg:block p-2 lg:p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors group">
                                    <Image className="w-4 h-4 lg:w-5 lg:h-5 text-gray-400 group-hover:text-green-500" />
                                </button>
                            </div>
                            <div className="flex-1 relative">
                                <input
                                    type="text"
                                    placeholder="Type a message..."
                                    value={messageInput}
                                    onChange={(e) => setMessageInput(e.target.value)}
                                    className="w-full px-3 lg:px-4 py-2.5 lg:py-3 rounded-lg lg:rounded-xl bg-gray-100 dark:bg-slate-700 text-xs lg:text-sm text-gray-700 dark:text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
                                />
                            </div>
                            <button className="p-2 lg:p-2.5 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors group sm:block hidden">
                                <Mic className="w-4 h-4 lg:w-5 lg:h-5 text-gray-400 group-hover:text-purple-500" />
                            </button>
                            <button className="p-2.5 lg:p-3 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg lg:rounded-xl text-white hover:opacity-90 transition-opacity shadow-lg shadow-blue-500/25">
                                <Send className="w-4 h-4 lg:w-5 lg:h-5" />
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                /* Empty State - Only shown on tablet/desktop when no contact selected */
                <div className="hidden md:flex flex-1 items-center justify-center bg-gray-50 dark:bg-slate-900/50">
                    <div className="text-center px-4">
                        <div className="w-32 h-32 lg:w-48 lg:h-48 mx-auto mb-4 lg:mb-6 relative">
                            {/* Chat Illustration */}
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="relative">
                                    {/* Phone 1 */}
                                    <div className="w-16 h-24 lg:w-24 lg:h-36 bg-white dark:bg-slate-700 rounded-xl lg:rounded-2xl shadow-xl border-2 lg:border-4 border-gray-200 dark:border-gray-600 transform -rotate-12 absolute -left-5 lg:-left-8 top-0">
                                        <div className="p-1.5 lg:p-2">
                                            <div className="w-full h-1.5 lg:h-2 bg-gray-200 dark:bg-slate-600 rounded mb-1 lg:mb-1.5"></div>
                                            <div className="w-3/4 h-1.5 lg:h-2 bg-gray-200 dark:bg-slate-600 rounded mb-2 lg:mb-3"></div>
                                            <div className="w-6 h-6 lg:w-8 lg:h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 mx-auto"></div>
                                        </div>
                                    </div>
                                    {/* Phone 2 */}
                                    <div className="w-16 h-24 lg:w-24 lg:h-36 bg-white dark:bg-slate-700 rounded-xl lg:rounded-2xl shadow-xl border-2 lg:border-4 border-gray-200 dark:border-gray-600 transform rotate-12 absolute -right-5 lg:-right-8 top-2 lg:top-4">
                                        <div className="p-1.5 lg:p-2">
                                            <div className="w-full h-1.5 lg:h-2 bg-gray-200 dark:bg-slate-600 rounded mb-1 lg:mb-1.5"></div>
                                            <div className="w-3/4 h-1.5 lg:h-2 bg-gray-200 dark:bg-slate-600 rounded mb-2 lg:mb-3"></div>
                                            <div className="w-6 h-6 lg:w-8 lg:h-8 rounded-full bg-gradient-to-br from-pink-500 to-rose-500 mx-auto"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h3 className="text-lg lg:text-xl font-semibold text-gray-800 dark:text-gray-200 mb-1.5 lg:mb-2">
                            Click User To Chat
                        </h3>
                        <p className="text-gray-500 dark:text-gray-400 text-xs lg:text-sm max-w-xs mx-auto">
                            Select a conversation from the left panel to start chatting
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}
